import { S as g } from "./chunk-SwiperElement-lRkrDvjn.js";
import { d as h } from "./chunk-debounce-Bk6yKvzA.js";
import { t as d } from "./chunk-custom-element-CN0MC8o7.js";
import { n as u } from "./chunk-property---aaewZr.js";
const y = ".swiper{--swiper-pagination-bottom:15px;--swiper-pagination-bullet-horizontal-gap:2.5px}.swiper-pagination{box-sizing:border-box;justify-content:center;padding:0 14px;display:flex}.swiper-horizontal>.swiper-pagination-bullets,.swiper-pagination-bullets.swiper-pagination-horizontal{width:50%;right:0;top:var(--pagination-top);bottom:var(--pagination-bottom);margin:auto}@media (min-width:768px){.swiper-horizontal>.swiper-pagination-bullets,.swiper-pagination-bullets.swiper-pagination-horizontal{top:unset;bottom:var(--swiper-pagination-bottom,8px)}}.swiper-pagination-bullet{width:var(--pagination-size,24px);height:var(--pagination-size,24px);opacity:1;background:0 0;position:relative}.progress-circle{width:50%;height:50%;display:block;position:absolute;top:25%;left:25%}.progress-background{stroke-linecap:round;stroke:var(--swiper-bullet-bg)}.swiper-pagination-bullet-active .progress-background{stroke:var(--swiper-active-bullet-bg)}.progress{stroke-linecap:round;transform-origin:50%;stroke-dasharray:377;stroke-dashoffset:377px;transform:rotate(-90deg)}.swiper-pagination-bullet-active .progress-circle .progress{stroke-dashoffset:calc(377*var(--progress))}";
var b = Object.defineProperty, f = Object.getOwnPropertyDescriptor, n = (t, e, r, o) => {
  for (var s = o > 1 ? void 0 : o ? f(e, r) : e, i = t.length - 1, a; i >= 0; i--)
    (a = t[i]) && (s = (o ? a(e, r, s) : a(s)) || s);
  return o && s && b(e, r, s), s;
};
let l = class extends g {
  constructor() {
    super(...arguments), this.progressColor = "", this.progressBgColor = "", this.swiper = null, this.wasManuallyPaused = !1, this.playButton = null, this.swiperOptions = {
      injectStyles: [y],
      on: {
        beforeSlideChangeStart: (t) => {
          this._stopMediaInSlide(t.slides[t.activeIndex]);
        },
        click: (t, e) => {
          t.autoplay.stop(), this.wasManuallyPaused = !0;
        },
        init: (t) => {
          var r, o;
          if (this.swiper = t, typeof t.params.autoplay == "object") {
            if (this.style.setProperty(
              "--swiper-transition-duration",
              `${((r = t.params.autoplay) == null ? void 0 : r.delay) ?? 0}ms`
            ), !this.progressBgColor)
              return;
            this.style.setProperty("--swiper-bullet-bg", this.progressBgColor), this.style.setProperty(
              "--swiper-active-bullet-bg",
              this.progressBgColor
            );
          }
          (o = this.querySelectorAll("video")) == null || o.forEach((s) => {
            s.addEventListener("timeupdate", () => {
              t.autoplay.running || s.currentTime > 5 && (s.pause(), s.currentTime = 0);
            });
          }), this.playButton = this.querySelector(
            "[data-hero-autoplay-button]"
          ), this.playButton && (this.playButton.addEventListener("click", () => {
            t.autoplay.running ? (t.autoplay.stop(), this.wasManuallyPaused = !0) : (t.autoplay.start(), this.wasManuallyPaused = !1);
          }), this.playButton.tabIndex = 0);
          const e = t.el.querySelector(".swiper-wrapper");
          e && e.addEventListener("scroll", (s) => {
            const i = this.style.getPropertyValue("--progress");
            parseFloat(i) < 0.8 && (t.autoplay.stop(), this.wasManuallyPaused = !0);
          }), this.handleControlColors();
        },
        autoplayStart: (t) => {
          this.setAttribute("data-playing", "true"), this.style.setProperty(
            "--swiper-active-bullet-bg",
            this.progressBgColor
          );
          const e = t.slides[t.activeIndex].querySelector("video");
          e && (e.loop = !0, e.play());
        },
        autoplayStop: () => {
          var t;
          this.setAttribute("data-playing", "false"), this.style.setProperty("--swiper-active-bullet-bg", this.progressColor), (t = this.querySelector("video")) == null || t.pause();
        },
        slideChange: (t) => {
          const e = t.slides[t.activeIndex].querySelector("video");
          e && (e.play(), t.autoplay.running || (e.autoplay = !1, e.loop = !1)), this.handleControlColors();
        },
        autoplayTimeLeft: (t, e, r) => (r < 0.85 ? this.style.setProperty("--progress", `${r}`) : this.style.setProperty("--progress", "1"), {
          swiper: t,
          timeLeft: e
        })
      },
      pagination: {
        renderBullet: (t, e) => `
          <span class="${e}">
            <svg class="progress-circle" role="none" viewBox="0 0 150 150">
              <circle class="progress-background" cx="75" cy="75" r="60" stroke-width="12" fill="none" />
              <circle class="progress" cx="75" cy="75" r="60" stroke="${this.progressColor}" stroke-width="12" fill="none"
              stroke-dasharray="377" stroke-dashoffset="0" />
            </svg>
          </span>
        `
      },
      breakpoints: {
        768: {
          autoHeight: !1
        }
      },
      fadeEffect: {
        crossFade: !0
      }
    }, this.handleResize = h(() => {
      if (!this.playButton) return;
      const t = window.innerWidth <= 768;
      this.swiper && (t ? this.swiper.autoplay.running && this.swiper.autoplay.stop() : !this.swiper.autoplay.running && !this.wasManuallyPaused && this.swiper.autoplay.start());
    }, 200);
  }
  handleControlColors() {
    var i, a, p;
    const t = (a = this.swiper) == null ? void 0 : a.slides[(i = this.swiper) == null ? void 0 : i.activeIndex], e = t == null ? void 0 : t.getAttribute("data-controls-color"), r = (p = this.swiper) == null ? void 0 : p.pagination.el, o = this.querySelectorAll("[data-hero-autoplay-button] svg"), s = e === "dark";
    r && r.style.setProperty("filter", s ? "invert(1)" : ""), o.forEach((c) => {
      c.classList.toggle("invert", s);
    });
  }
  connectedCallback() {
    super.connectedCallback(), window.addEventListener("resize", this.handleResize), this.handleResize();
  }
  disconnectedCallback() {
    super.disconnectedCallback(), window.removeEventListener("resize", this.handleResize);
  }
  _stopMediaInSlide(t) {
    const e = t.querySelector("video");
    e == null || e.pause();
  }
};
n([
  u({ type: String, attribute: "progress-color" })
], l.prototype, "progressColor", 2);
n([
  u({ type: String, attribute: "progress-bg-color" })
], l.prototype, "progressBgColor", 2);
l = n([
  d("swiper-with-timer-dots")
], l);
export {
  l as SwiperWithTimerDots
};
